import React, { useContext, useEffect, useState } from 'react'
import Content from './components/Content';

import LogosSponsor from './components/Tabs/LogosSponsor';
import AdditionalImage from './components/Tabs/AdditionalImage';
import Image from './components/Tabs/Image';
import BuilderContext from '../../builder/hooks/context';
import pickBy from "lodash/pickBy";
import Markup from "../../markup";
import { trackStage, trackSubStage, trackTimeSpentOnStage } from '../../utils/Analytics';

function Logos() {
  const { builder } = useContext(BuilderContext);
  const [stageStartTime, setStageStartTime] = useState<number>(Date.now());

  const Components = {
    sponsor: LogosSponsor,
    image: Image,
    additional_images: AdditionalImage,
  };

  const filteredComponents = pickBy(Components, (value, key) => {
    switch(key){
      case "sponsor": return builder?.logoTabs?.sponsorLogo;
      case "image": return builder?.logoTabs?.image;
      case "additional_images": return builder?.logoTabs?.additionalImage;
      default:return true;
    }
  })

  useEffect(() => {
    setStageStartTime(Date.now());

    return () => {
      trackTimeSpentOnStage('Logos', stageStartTime);
    };
  }, []);

  useEffect(() => {
    trackStage('Logos');
    trackSubStage('Logos', 'Images');
  }, []);

  useEffect(() => {
    if(!builder?.animationState){
      builder?.setAnimationState(true);
      builder?.setCamera('front');
    }
  }, []);

  // Tell the interaction layer we're on the Images tab so logos/images can be dragged/resized
  useEffect(() => {
    builder?.setUiContext({ tab: 'Images' });
  }, []);
  
  return (
    <>
      <Markup.Screen.Logos.NoticeMessageTabs themeColor={builder.membersData.colorTheme} disOverOther={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}>
        Unable to make changes to this item because it has already been added to cart
      </Markup.Screen.Logos.NoticeMessageTabs>
      <Markup.Screen.Name.DisableOverlayOther themeColor={builder.membersData.colorTheme} disOverOther={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}>
      </Markup.Screen.Name.DisableOverlayOther>
      <Content Components={filteredComponents} page='logos' />
    </>
  );
}

export default React.memo(Logos);
